export const cropName = (name) => {
  return name.slice(0, 10) + "...";
};
